const TradingPeriod = {
  length: {
    inMinutes: 30,
    inSeconds: 30 * 60,
    inMilliseconds: 30 * 60 * 1000
  }
}
export default TradingPeriod